module.exports = __webpack_public_path__ + "static/media/theme_song.75b6672f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/theme_song.pdf
// module id = 293
// module chunks = 2